
import { computed, ComputedRef, defineComponent, PropType } from "vue";
import { toLocaleDateTime } from "../../components/mixins";
import { User } from "../../../../domain/entities/entities";
import { useStore } from "vuex";
import { dispatchError } from "../../utils/error_handling";
import { UserLikes } from "../../../../domain/entities/rating";
import { useRoute } from "vue-router";
import { wrapLoading } from "../../utils/wrap_loading";

export default defineComponent({
  name: "ContentComment",
  props: {
    id: {
      type: Number,
      default: 0
    },
    userName: {
      type: String,
      required: true
    },
    userImage: {
      type: String,
      required: true
    },
    userID: {
      type: Number,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    stars: {
      type: Number
    },
    comment: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    likes: {
      type: Object as PropType<UserLikes[]>,
      default: []
    },
    tab: {
      type: String as PropType<"Ratings" | "Doubts">,
      default: ""
    }
  },

  setup(props) {
    const store = useStore();

    const route = useRoute();

    const user: ComputedRef<User> = computed(
      () => store.getters["userProfile_module/user"]
    );

    const likeRating = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/rating/likeRating", {
          ratingID: props.id,
          userID: user.value.id
        });
      } catch (e) {
        console.error("[create rating] Error dispatch ", e);
        throw e;
      }
    };

    const removeLikeRating = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/rating/removeLikeRating", {
          ratingID: props.id,
          userID: user.value.id
        });
      } catch (e) {
        console.error("[create rating] Error dispatch ", e);
        throw e;
      }
    };

    const onSubmit = async (): Promise<void> => {
      try {
        if (isLiked()) {
          await removeLikeRating();
        } else {
          await likeRating();
        }
      } catch (e) {
        console.error("[onSubmit] Error createRating ", e);
        await dispatchError(e);
      }
    };

    const isLiked = (): boolean => {
      if (!props.likes) return false;
      const likeIDs = props.likes.map(
        (userLikes: UserLikes) => userLikes.userID
      );
      return likeIDs.includes(user.value.id);
    };

    const deleteRating = async (): Promise<void> => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("content_module/rating/deleteRating", props.id);
        });
      } catch (e) {
        console.error("[deleteRating] Error createRating ", e);
        await dispatchError(e);
      }
    };

    return {
      user,
      toLocaleDateTime,
      onSubmit,
      isLiked,
      deleteRating
    };
  }
});
